module.exports = __webpack_public_path__ + "static/media/IndhiraGandhi2.e2fc36bb.jpeg";